module.exports = __webpack_public_path__ + "img/icon_alert00.8d794903.png";